import { EyeIcon } from 'assets';
import React, { useMemo } from 'react';
import styles from '../style.module.scss';
import useCountdown from '../../hook/useCountDown';
import { calculateDifferenceInHours } from 'shared/utils/Helper';
import { routeConstant } from 'shared/routes/RouteConstant';
import { useNavigate } from 'react-router-dom';
import { toastMessage } from 'shared/components/toast/Toast';
import moment from 'moment';

export default function InprogressColumn({ inprogress, Index }) {
    const task_time = useMemo(() => {
        const givenDateStr = inprogress?.task_assigned_date;
        const givenDate = new Date(givenDateStr);
        const currentDate = new Date();
        const differenceInSeconds = calculateDifferenceInHours(currentDate, givenDate);

        return differenceInSeconds;
    }, [inprogress]);

    const navigate = useNavigate();
    const { hours, minutes, seconds, isNegative, stopTimer } = useCountdown(task_time);
    const navigateToPath = (taskInprogress) => {
        navigate(routeConstant.user.wopt.path, { state: { taskInprogress } });
    };

    const sku = inprogress?.task_inventory?.sku || inprogress?.task_sku || 'N/A';
    const brand = inprogress?.task_brand?.name || '';
    const ccpb = inprogress?.task_compatiableBrand?.name || '';
    const subcat = inprogress?.task_subcategory?.name || '';
    const cat = inprogress?.task_category?.name || '';
    const color = inprogress?.task_inventory?.color || inprogress?.task_color || inprogress?.color || '';
    const model = inprogress?.task_product?.name || inprogress?.task_product?.model || (inprogress?.name && inprogress?.name !== 'Rough Listing Item' ? inprogress?.name : '') || '';
    const titleDetails = `${ccpb} ${model} ${cat} ${subcat} ${color}`.replace(/\s+/g, ' ').trim();

    return (
        <div className={styles.ListingFlex}>
            <div className={styles.CardHeader}>
                <div
                    className={styles.SKU}
                    title="Click to copy SKU"
                    onClick={() => {
                        if (sku !== 'N/A') {
                            navigator.clipboard.writeText(sku);
                            toastMessage('success', 'SKU Copied!');
                        }
                    }}
                >
                    {sku}
                </div>
                <div className={styles.DateAndPriority}>
                    <div className={styles.TimerBox}>
                        {isNegative ? '-' : ''}
                        {hours}h {minutes}m {seconds.toFixed(0)}s
                    </div>
                    {inprogress?.priority && (
                        <span className={inprogress.priority == 'HIGH' ? styles.periorityON : inprogress.priority == 'MIDDLE' ? styles.periorityORANGE : styles.periority}></span>
                    )}
                </div>
            </div>
            <div className={styles.CardBody}>
                <p
                    className={styles.TaskTitle}
                    title="Click to copy Title Details"
                    onClick={() => {
                        if (titleDetails) {
                            navigator.clipboard.writeText(titleDetails);
                            toastMessage('success', 'Details Copied!');
                        }
                    }}
                >
                    {titleDetails}
                </p>
            </div>
            <div className={styles.CardFooter}>
                <div className={styles.Brand}>{inprogress?.task_brand?.name || 'N/A'}</div>
                <div className={styles.ActionButtons}>
                    <EyeIcon
                        onClick={() => {
                            navigateToPath(inprogress);
                        }}
                    />
                    <span className={styles.Score}>Score: {inprogress.task_point || 0}</span>
                </div>
            </div>
        </div>
    );
}
